import React, { useEffect, useState } from 'react'
import DashboardStyle from '../Dashboard'
import { customFuncsApi } from '../../../api'
import { get } from 'lodash'
import ClipLoader from 'react-spinners/ClipLoader'
import dayjs from 'dayjs'
import { DatePicker, Empty } from 'antd'
import { useTranslation } from 'react-i18next'
import numberWithSpaces from '../../../helpers/numberWithSpaces'

const { RangePicker } = DatePicker

const columns = [
	{ key: 'Ombor', title: 'whs', isText: true },
	{ key: 'SavdoSoni', title: 'salesCount' },
	{ key: 'KunlikOrtachaSavdo', title: 'dailyAvgSales' },
	{ key: 'KutilayotganSavdo', title: 'expectedSales' },
	{ key: 'SavdoSummasi', title: 'salesAmount' },
	{ key: 'TikilganPul', title: 'investedMoney' },
	{ key: 'KutilayotganTikiladiganPul', title: 'expectedInvestedMoney' },
	{ key: 'Foyda', title: 'profit' },
	{ key: 'KutilayotganFoyda', title: 'expectedProfit' },
]

export default function Tab3() {
	const { t } = useTranslation()
	const dateFormat = 'YYYY-MM-DD'

	const [startDate, setStartDate] = useState(
		dayjs().startOf('month').format(dateFormat),
	)
	const [endDate, setEndDate] = useState(dayjs().format(dateFormat))
	const [data, setData] = useState([])
	const [isLoading, setIsLoading] = useState(false)
	const [error, setError] = useState('')

	const fetchData = () => {
		setIsLoading(true)
		setError('')
		customFuncsApi
			.get(`xsSql/getSalesForecastByWhs?date1=${startDate}&date2=${endDate}`, {
				headers: { Prefer: 'odata.maxpagesize=1000' },
			})
			.then((res) => {
				setData(get(res, 'data.value', []))
			})
			.catch((err) => {
				setData([])
				setError(
					String(get(err, 'response.data.message', '') || err.message || ''),
				)
			})
			.finally(() => {
				setIsLoading(false)
			})
	}

	useEffect(() => {
		if (startDate && endDate) {
			fetchData()
		}
	}, [startDate, endDate])

	const onRangeChange = (dates) => {
		if (dates) {
			setStartDate(dates[0].format(dateFormat))
			setEndDate(dates[1].format(dateFormat))
		}
	}

	const formatValue = (value) =>
		numberWithSpaces(Math.round(Number(value || 0) * 100) / 100)

	return (
		<DashboardStyle>
			<div className="container minWidthContainer">
				<p className="productTitle mb-10">{t('salesForecast')}</p>
				<RangePicker
					value={[dayjs(startDate, dateFormat), dayjs(endDate, dateFormat)]}
					format={dateFormat}
					allowClear={false}
					onChange={onRangeChange}
				/>
				{isLoading ? (
					<div
						style={{ display: 'flex', justifyContent: 'center' }}
						className="mt-8"
					>
						<ClipLoader
							loading={true}
							size={20}
							aria-label="Loading Spinner"
							className={'loader'}
							data-testid="loader"
						/>
					</div>
				) : (
					<div className="overflow-x-auto mb-8 mt-8">
						<table className="w-full text-sm text-left rtl:text-right text-gray-500 ">
							<thead className="text-xs text-gray-700 uppercase bg-gray-50 ">
								<tr>
									{columns.map((c) => (
										<th key={c.key} scope="col" className="px-6 py-4">
											{t(c.title)}
										</th>
									))}
								</tr>
							</thead>
							<tbody>
								{data.length > 0 ? (
									data.map((v, i) => (
										<tr key={i} className="bg-white border-b hover:bg-gray-50 ">
											{columns.map((c) => (
												<td
													key={c.key}
													className={
														c.isText
															? 'px-6 py-4 font-medium text-gray-900 '
															: 'px-6 py-4 whitespace-nowrap'
													}
												>
													{c.isText ? v[c.key] : formatValue(v[c.key])}
												</td>
											))}
										</tr>
									))
								) : (
									<tr>
										<td colSpan={columns.length}>
											<Empty
												description={error || t('noInfo')}
												image={Empty.PRESENTED_IMAGE_SIMPLE}
											/>
										</td>
									</tr>
								)}
							</tbody>
						</table>
					</div>
				)}
			</div>
		</DashboardStyle>
	)
}
